import { render, staticRenderFns } from "./AdmitDownloadNew.vue?vue&type=template&id=aef2a3f8&scoped=true&"
import script from "./AdmitDownloadNew.vue?vue&type=script&lang=js&"
export * from "./AdmitDownloadNew.vue?vue&type=script&lang=js&"
import style0 from "./AdmitDownloadNew.vue?vue&type=style&index=0&id=aef2a3f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef2a3f8",
  null
  
)

export default component.exports